import React from "react";

const summary = <p>A dramatic short about a couple who chooses the destination in favor of the journey when scaling the mountain of life. 2009</p>;

export default summary;